"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EExternalServiceMethods = exports.EExternalServices = void 0;
var EExternalServices;
(function (EExternalServices) {
    EExternalServices["AUTH_SERVICE"] = "AUTH_SERVICE";
    EExternalServices["USER_SERVICE"] = "USER_SERVICE";
    EExternalServices["ORGANIZATION_SERVICE"] = "ORGANIZATION_SERVICE";
    EExternalServices["APP_SERVICE"] = "APP_SERVICE";
    EExternalServices["BACKUP_SERVICE"] = "BACKUP_SERVICE";
    EExternalServices["TE_SERVER"] = "TE_SERVER";
    EExternalServices["INTEGRATION_SERVICE"] = "INTEGRATION_SERVICE";
    EExternalServices["PATHWAY_SERVICE"] = "PATHWAY_SERVICE";
    EExternalServices["TE_PREFERENCES"] = "TE_PREFERENCES";
    EExternalServices["ACTIVITY_MANAGER"] = "ACTIVITY_MANAGER";
    EExternalServices["REPORTING"] = "REPORTING";
    EExternalServices["NOTIFICATION"] = "NOTIFICATION_SERVICE";
    EExternalServices["SEAT_MANAGEMENT_SERVICE"] = "SEAT_MANAGEMENT_SERVICE";
})(EExternalServices = exports.EExternalServices || (exports.EExternalServices = {}));
var EExternalServiceMethods;
(function (EExternalServiceMethods) {
    EExternalServiceMethods["GET"] = "get";
    EExternalServiceMethods["POST"] = "post";
    EExternalServiceMethods["PUT"] = "put";
    EExternalServiceMethods["PATCH"] = "patch";
    EExternalServiceMethods["DELETE"] = "delete";
})(EExternalServiceMethods = exports.EExternalServiceMethods || (exports.EExternalServiceMethods = {}));
